/**
 * charma-promo-modal.js  — v2
 * Clickable promo banner popup for ALL Charma Italia charm product pages.
 * Matches the style of the collection-page popup (ai_gen_block_9a81768).
 * Offers a choice between Gold and Silver bracelet.
 *
 * HOW TO INSTALL (already done — just replace the file in Assets):
 *   Shopify Admin → Online Store → Themes → Edit code → Assets → charma-promo-modal.js
 *   Select all → paste → Save
 */

(function () {
  'use strict';

  /* jazyk: cs (charma.cz) / sk (charma.sk) */
  var L = (document.documentElement.lang || '').toLowerCase().indexOf('cs') === 0;

  var MODAL_ID = 'charma-promo-modal';
  var ACCENT   = '#2d7a5f';   /* same green as collection-page popup */

  /* Images that trigger the popup (banner images found in all Nomination product descriptions) */
  var PROMO_PATTERNS = [
    'a133f8b6-c369-426e-9f9c-ff9aabf2894e',  /* charm promo banner old (legacy) */
    'ChatGPT_Image_4_._2026_._20_47_45',      /* charm promo banner new — 7+ = GIFT FREE (acc250) */
    'ChatGPT_Image_4_._2026_._21_20_16',      /* charm promo banner new — 7+ = GIFT FREE (acc251) */
    'ChatGPT_Image_5_._2026_._16_15_46',      /* acc251 gold bracelet page — banner 1 */
    'ChatGPT_Image_5_._2026_._16_28_12'       /* acc251 gold bracelet page — banner 2 */
  ];

  var HEADING_CLASS = 'ai-promo-banner-heading-amhrznhbjsutucgj6naigenblock9a81768unwpdy';

  /* ─── helpers ──────────────────────────────────────────────────────────── */

  function css(obj) {
    return Object.keys(obj).map(function (k) { return k + ':' + obj[k]; }).join(';');
  }

  function stepHTML(num, html) {
    return '<li style="' + css({ display:'flex', 'align-items':'flex-start', gap:'14px', margin:'0 0 16px 0' }) + '">'
      + '<span style="' + css({
          'flex-shrink':'0', width:'32px', height:'32px', 'border-radius':'50%',
          background: ACCENT, color:'#fff', 'font-size':'14px', 'font-weight':'700',
          display:'flex', 'align-items':'center', 'justify-content':'center'
        }) + '">' + num + '</span>'
      + '<span style="font-size:14px;color:#333;line-height:1.6;padding-top:5px;">' + html + '</span>'
      + '</li>';
  }

  /* ─── modal HTML ────────────────────────────────────────────────────────── */

  function buildModal() {
    var el = document.createElement('div');
    el.id = MODAL_ID;
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-labelledby', MODAL_ID + '-title');
    el.style.cssText = css({
      display: 'none',
      position: 'fixed',
      inset: '0',
      background: 'rgba(0,0,0,0.55)',
      'backdrop-filter': 'blur(3px)',
      'z-index': '100000',
      'align-items': 'center',
      'justify-content': 'center',
      padding: '16px',
      'box-sizing': 'border-box'
    });

    if ((document.documentElement.lang || '').toLowerCase().indexOf('pl') === 0) {
      el.innerHTML = "<div id=\"charma-promo-modal-box\" style=\"background:#fff;border-radius:20px;padding:32px;max-width:520px;width:100%;position:relative;max-height:90vh;overflow-y:auto;box-sizing:border-box\">\n<button id=\"charma-promo-modal-close\" aria-label=\"Zamknij\" style=\"position:absolute;top:12px;right:12px;border:0;border-radius:50%;width:34px;height:34px;cursor:pointer\">✕</button>\n<span style=\"font-size:36px\">🎁</span><h2 id=\"charma-promo-modal-title\">Jak otrzymać bransoletkę GRATIS?</h2>\n<p>Kup <strong>7 charmsów Charma Italia</strong> i odbierz wybraną bransoletkę gratis. Za każde kolejne 7 charmsów możesz otrzymać kolejną bransoletkę.</p>\n<ol style=\"padding-left:20px;line-height:1.65\"><li>Dodaj do koszyka co najmniej 7 charmsów z kolekcji Charma Italia.</li><li>Wybierz bransoletkę i również dodaj ją do koszyka:\n<div style=\"display:flex;gap:8px;flex-wrap:wrap;margin:12px 0\">\n<a href=\"/pl/products/acc250\" style=\"border:1px solid #c8e6d5;border-radius:8px;padding:8px 12px;color:#2d7a5f\">Srebrna</a><a href=\"/pl/products/acc251\" style=\"border:1px solid #c8e6d5;border-radius:8px;padding:8px 12px;color:#2d7a5f\">Złota</a><a href=\"/pl/products/acc252\" style=\"border:1px solid #c8e6d5;border-radius:8px;padding:8px 12px;color:#2d7a5f\">Różowe złoto</a><a href=\"/pl/products/acc254\" style=\"border:1px solid #c8e6d5;border-radius:8px;padding:8px 12px;color:#2d7a5f\">Niebieska</a><a href=\"/pl/products/acc255\" style=\"border:1px solid #c8e6d5;border-radius:8px;padding:8px 12px;color:#2d7a5f\">Czarna</a>\n</div></li><li>Po spełnieniu warunków cena bransoletki w koszyku automatycznie spadnie do <strong>0 €</strong>.</li></ol>\n<div style=\"background:#f7fdf9;border:1px solid #c8e6d5;border-radius:12px;padding:16px;margin:18px 0\"><strong>Warunki promocji</strong><ul style=\"padding-left:18px;line-height:1.6\"><li>Minimum 7 charmsów Charma Italia.</li><li>7 charmsów = 1 bransoletka gratis; 14 = 2 itd.</li><li>Charmsy i wybrana bransoletka muszą znajdować się w koszyku.</li><li>Dostępne bazy: srebrna, złota, różowe złoto, niebieska i czarna.</li><li>Promocja do wyczerpania zapasów.</li></ul></div><a href=\"/pl/collections/nomination-1\" style=\"display:block;padding:14px;text-align:center;border-radius:10px;background:#2d7a5f;color:#fff;text-decoration:none\">Wybierz charmsy Charma Italia →</a></div>";
      return el;
    }

    /* inject keyframe animation once */
    if (!document.getElementById(MODAL_ID + '-style')) {
      var s = document.createElement('style');
      s.id = MODAL_ID + '-style';
      s.textContent = '@keyframes charmaModalIn{from{opacity:0;transform:scale(.94) translateY(10px)}to{opacity:1;transform:scale(1) translateY(0)}}';
      document.head.appendChild(s);
    }

    el.innerHTML =
      '<div id="' + MODAL_ID + '-box" style="' + css({
        background: '#fff',
        'border-radius': '20px',
        padding: '40px 36px 32px',
        'max-width': '520px',
        width: '100%',
        position: 'relative',
        'box-shadow': '0 24px 64px rgba(0,0,0,0.18)',
        'max-height': '90vh',
        'overflow-y': 'auto',
        animation: 'charmaModalIn 0.25s ease',
        'box-sizing': 'border-box'
      }) + '">'

        /* close button */
        + '<button id="' + MODAL_ID + '-close" aria-label="' + (L ? 'Zavřít' : 'Zavrieť') + '" style="'
        + css({ position:'absolute', top:'14px', right:'14px', width:'34px', height:'34px',
                background:'#f0f0f0', border:'none', 'border-radius':'50%', cursor:'pointer',
                'font-size':'22px', 'line-height':'1', color:'#555',
                display:'flex', 'align-items':'center', 'justify-content':'center' })
        + '">&#x2715;</button>'

        /* emoji + title */
        + '<span style="font-size:38px;margin-bottom:10px;display:block;">🎁</span>'
        + '<h2 id="' + MODAL_ID + '-title" style="font-size:22px;font-weight:700;color:#1a1a1a;margin:0 0 8px;">' + (L ? 'Jak získáte náramek ZDARMA?' : 'Ako získate náramok ZADARMO?') + '</h2>'
        + '<p style="font-size:14px;color:#666;margin:0 0 26px;line-height:1.6;">' + (L ? 'Při nákupu <strong>7 a více přívěsků</strong> Charma Italia vám náramek darujeme — bez kupónů, bez komplikací.' : 'Pri nákupe <strong>7 a viac príveskov</strong> Charma Italia vám náramok darujeme — bez kupónov, bez komplikácií.') + ' <strong style="color:' + ACCENT + ';">' + (L ? 'Za každých dalších 7 přívěsků můžete získat další náramek zdarma.' : 'Za každých ďalších 7 príveskov môžete získať ďalší náramok zadarmo.') + '</strong></p>'

        /* steps */
        + '<ol style="list-style:none;padding:0;margin:0 0 22px;">'
        + stepHTML(1, '' + (L ? 'Přidejte do košíku <strong>7 nebo více přívěsků</strong> z kolekce Charma Italia.' : 'Pridajte do košíka <strong>7 alebo viac príveskov</strong> z kolekcie Charma Italia.') + '')
        + stepHTML(2, '' + (L ? 'Vyberte si náramek zdarma a přidejte ho do košíku:' : 'Vyberte si náramok zadarmo a pridajte ho do košíka:') + ''
            /* bracelet choice cards */
            + '<div style="display:flex;gap:12px;margin-top:12px;flex-wrap:wrap;">'

              /* GOLD */
              + '<div onclick="window.location.href=\'/products/acc251\'" style="flex:1;min-width:130px;display:flex;flex-direction:column;align-items:center;gap:0;border:2px solid #d4af37;border-radius:14px;background:#fff;overflow:hidden;transition:box-shadow .2s;cursor:pointer;" onmouseover="this.style.boxShadow=\'0 6px 20px rgba(212,175,55,.4)\'" onmouseout="this.style.boxShadow=\'none\'">'
              + '<img src="https://cdn.shopify.com/s/files/1/0607/1163/3101/files/IMG_9978_300x300_crop_center.png?v=1772651620" alt="Charma Italia Gold" style="width:100%;aspect-ratio:1;object-fit:cover;display:block;">'
              + '<div style="width:100%;padding:10px 8px;text-align:center;background:linear-gradient(135deg,#fdf9ee,#f5e8bb);">'
              + '<div style="font-size:12px;font-weight:700;color:#8a6a00;letter-spacing:.04em;">GOLD</div>'
              + '<div style="font-size:11px;color:#a07800;margin-top:2px;">Charma Italia</div>'
              + '</div>'
              + '</div>'

              /* SILVER */
              + '<div onclick="window.location.href=\'/products/acc250\'" style="flex:1;min-width:130px;display:flex;flex-direction:column;align-items:center;gap:0;border:2px solid #b0b0b0;border-radius:14px;background:#fff;overflow:hidden;transition:box-shadow .2s;cursor:pointer;" onmouseover="this.style.boxShadow=\'0 6px 20px rgba(0,0,0,.18)\'" onmouseout="this.style.boxShadow=\'none\'">'
              + '<img src="https://cdn.shopify.com/s/files/1/0607/1163/3101/files/IMG-9740_300x300_crop_center.png?v=1772027408" alt="Charma Italia Silver" style="width:100%;aspect-ratio:1;object-fit:cover;display:block;">'
              + '<div style="width:100%;padding:10px 8px;text-align:center;background:linear-gradient(135deg,#f5f5f5,#e0e0e0);">'
              + '<div style="font-size:12px;font-weight:700;color:#555;letter-spacing:.04em;">SILVER</div>'
              + '<div style="font-size:11px;color:#777;margin-top:2px;">Charma Italia</div>'
              + '</div>'
              + '</div>'

            + '</div>')
        + stepHTML(3, '' + (L ? 'Náš tým objednávku zkontroluje a <strong>náramek vám přiloží jako dárek</strong> 🎀' : 'Náš tím objednávku skontroluje a <strong>náramok vám priloží ako darček</strong> 🎀') + '')
        + '</ol>'

        /* conditions */
        + '<div style="' + css({ background:'#f7fdf9', border:'1px solid #c8e6d5', 'border-radius':'12px', padding:'16px 18px', margin:'0 0 24px' }) + '">'
        + '<p style="font-size:11px;font-weight:700;color:#888;margin:0 0 10px;text-transform:uppercase;letter-spacing:.08em;">' + (L ? 'Podmínky akce' : 'Podmienky akcie') + '</p>'
        + '<ul style="list-style:none;padding:0;margin:0;display:flex;flex-direction:column;gap:6px;">'
        + ['' + (L ? 'Platí při nákupu min. 7 přívěsků z kolekce Charma Italia' : 'Platí pri kúpe min. 7 príveskov z kolekcie Charma Italia') + '',
           '' + (L ? 'Za každých 7 přívěsků — 1 náramek zdarma (7 = 1, 14 = 2, ...)' : 'Za každých 7 príveskov — 1 náramok zadarmo (7 = 1, 14 = 2, ...)') + '',
           '' + (L ? 'Náramek musí být v košíku (silver nebo gold)' : 'Náramok musí byť v košíku (silver alebo gold)') + '',
           '' + (L ? 'Akce platí do vyprodání zásob' : 'Akcia platí do vypredania zásob') + ''].map(function (t) {
             return '<li style="font-size:13px;color:#555;padding-left:18px;position:relative;line-height:1.5;">'
               + '<span style="position:absolute;left:0;color:' + ACCENT + ';font-weight:700;">✓</span>' + t + '</li>';
           }).join('')
        + '</ul>'
        + '</div>'

        /* CTA */
        + '<a href="/collections/nomination-1" style="' + css({
            display:'block', width:'100%', padding:'14px',
            background: ACCENT, color:'#fff', border:'none', 'border-radius':'12px',
            'font-size':'15px', 'font-weight':'600', cursor:'pointer',
            'text-align':'center', 'text-decoration':'none', 'box-sizing':'border-box'
          }) + '">' + (L ? 'Vybrat přívěsky Charma Italia →' : 'Vybrať prívesy Charma Italia →') + '</a>'

      + '</div>';

    return el;
  }

  /* ─── open / close ──────────────────────────────────────────────────────── */

  function openModal() {
    var m = document.getElementById(MODAL_ID);
    if (!m) return;
    /* re-trigger animation */
    var box = document.getElementById(MODAL_ID + '-box');
    if (box) { box.style.animation = 'none'; box.offsetHeight; box.style.animation = ''; }
    m.style.display = 'flex';
    document.body.style.overflow = 'hidden';
    var close = document.getElementById(MODAL_ID + '-close');
    if (close) close.focus();
  }

  function closeModal() {
    var m = document.getElementById(MODAL_ID);
    if (!m) return;
    m.style.display = 'none';
    document.body.style.overflow = '';
  }

  /* ─── init ──────────────────────────────────────────────────────────────── */

  function isPromoBanner(img) {
    var src = img.getAttribute('src') || '';
    return PROMO_PATTERNS.some(function (p) { return src.indexOf(p) !== -1; });
  }

  function init() {
    var found = false;

    document.querySelectorAll('img').forEach(function (img) {
      if (isPromoBanner(img) && !img.dataset.charmaPromo) {
        found = true;
        img.dataset.charmaPromo = '1';
        img.style.cursor = 'pointer';
        img.title = '' + (L ? 'Klikněte pro detaily akce' : 'Kliknite pre detaily akcie') + '';
        img.setAttribute('role', 'button');
        img.setAttribute('tabindex', '0');
        img.addEventListener('click', function(e) { e.stopPropagation(); openModal(); });
        img.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openModal(); }
        });
      }
    });

    /* also make the h2 heading clickable */
    var heading = document.querySelector('.' + HEADING_CLASS);
    if (heading && !heading.dataset.charmaPromo) {
      found = true;
      heading.dataset.charmaPromo = '1';
      heading.style.cursor = 'pointer';
      heading.addEventListener('click', openModal);
    }

    if (!found) return;
    if (document.getElementById(MODAL_ID)) return; /* already injected */

    var modal = buildModal();
    document.body.appendChild(modal);

    document.getElementById(MODAL_ID + '-close').addEventListener('click', closeModal);
    modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.style.display === 'flex') closeModal();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); setTimeout(init, 800); });
  } else {
    init();
    setTimeout(init, 800);
  }

})();
